import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class CalculosPlataformaService extends ApiService {
  entityType = EntityType.CALCULO_PLATAFORMA;
  url = 'api/calculo-plataforma/';
}
